function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_668_"
}, /*#__PURE__*/React.createElement("g", {
  id: "XMLID_528_"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_545_",
  d: "m495 254.083h-30v-59.916c0-17.27-8.802-32.521-22.154-41.507l-149.731-149.731c-3.905-3.904-10.238-3.904-14.142 0l-30.461 30.46-30.46-30.46c-1.875-1.875-4.419-2.929-7.071-2.929s-5.196 1.054-7.071 2.929l-141.239 141.238h-5.671c-27.57 0-50 22.43-50 50v88.916c0 5.522 4.477 10 10 10s10-4.478 10-10v-88.916c0-16.542 13.458-30 30-30h358c16.542 0 30 13.458 30 30v59.916h-152c-40.804 0-74 33.196-74 74s33.196 74 74 74h152v59.917c0 16.542-13.458 30-30 30h-358c-16.542 0-30-13.458-30-30v-88.917c0-5.523-4.477-10-10-10s-10 4.477-10 10v88.917c0 27.57 22.43 50 50 50h358c27.57 0 50-22.43 50-50v-59.917h30c5.523 0 10-4.478 10-10v-128c0-5.523-4.477-10-10-10zm-404.044-109.916 120.025-120.024 23.388 23.389-96.636 96.636h-46.777zm75.063 0 120.024-120.024 120.025 120.024zm318.981 237.916h-192c-29.776 0-54-24.225-54-54s24.224-54 54-54h192z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1014_",
  d: "m293 298.083c-16.542 0-30 13.458-30 30s13.458 30 30 30 30-13.458 30-30-13.458-30-30-30zm0 40c-5.514 0-10-4.486-10-10s4.486-10 10-10 10 4.486 10 10-4.486 10-10 10z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1019_",
  d: "m17 338.08c2.63 0 5.21-1.061 7.07-2.931 1.86-1.859 2.93-4.439 2.93-7.069s-1.07-5.21-2.93-7.07-4.44-2.93-7.07-2.93-5.21 1.069-7.07 2.93c-1.86 1.86-2.93 4.44-2.93 7.07s1.07 5.21 2.93 7.069c1.86 1.871 4.44 2.931 7.07 2.931z"
})));

var SvgMoney = function SvgMoney(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoney, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/money.1c59a725.svg";
export { ForwardRef as ReactComponent };